"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPageParametersByBreadcrumb = void 0;
const buildPageParametersByUrl_1 = require("./buildPageParametersByUrl");
/**
 * Nimmt eine Breadcrumb (z.B. 'tarife.postpaid.allnet-flat-m') und den page_type entgegen und gibt die dazugehörigen page_ Parameter zurück.
 * Die Breadcrumb wird Teil der `page_content_id`, als Domain wird die aktuelle verwendet.
 *
 * @category Parameter
 * @param {Breadcrumb} breadcrumb
 * @param pageType
 *
 */
const buildPageParametersByBreadcrumb = (breadcrumb, pageType) => {
    const pagePath = breadcrumb.replaceAll('.', '/');
    return (0, buildPageParametersByUrl_1.buildPageParametersByUrl)(new URL(pagePath, window.location.origin), pageType);
};
exports.buildPageParametersByBreadcrumb = buildPageParametersByBreadcrumb;
